import React, { useState } from "react";
import { useEffect } from "react";
import {
  Input,
  CardTitle,
  FormGroup,
  Button,
  Form,
  CardSubtitle,
} from "reactstrap";

import { Colxx } from "../../../components/common/CustomBootstrap";
import { useHistory } from "react-router-dom";
import { ProfileService } from "../../../services/ProfileService";

const InviteToRatePeers = (props) => {
  const history = useHistory();
  const [invitePeerRequest, setInvitePeerRequest] = useState(props.peerRequest);
  const [selectionId, setSelectionId] = useState("");
  const [showPersonal, setShowPersonal] = useState(false);
  const [showEmployer, setShowEmployer] = useState(false);
  const [description, setDescription] = useState("");

  const [workedSameTeam, setWorkedSameTeam] = useState(false);
  const [workedDiffTeams, setWorkedDiffTeams] = useState(false);
  const [youSupervisedPeer, setYouSupervisedPeer] = useState(false);
  const [b2bRelation, setB2bRelation] = useState(false);
  const [customerRelation, setCustomerRelation] = useState(false);
  const [peerSupervisedYou, setPeerSupervisedYou] = useState(false);
  const [mentoringOrTraining, setMentoringOrTraining] = useState(false);
  const [academicRelation, setAcademicRelation] = useState(false);
  const [contactNumber, setContactNumber] = useState("");
  const [email, setEmail] = useState("");

  const [experiences, setExperiences] = useState([]);
  const [experiencesList, setExperiencesList] = useState([]);

  const sendPeerRequest = (event) => {
    const peerRequest = {
      workedSameTeam: workedSameTeam,
      youSupervisedPeer: youSupervisedPeer,
      b2bRelation: b2bRelation,
      customerRelation: customerRelation,
      workedDiffTeams: workedDiffTeams,
      peerSupervisedYou: peerSupervisedYou,
      mentoringOrTraining: mentoringOrTraining,
      academicRelation: academicRelation,
    };   
  };

  const close = (event) => {
    props.peerRatingCallback(false);
    event.preventDefault();
  };

  const handleSelectionChange = (e) => {
    setSelectionId(e.target.value);
    if (e.target.value == "personal") {
      setShowPersonal(true);
      setShowEmployer(false);
      setSelectionId(e.target.value);
    } else if (e.target.value == "") {
      setShowPersonal(false);
      setShowEmployer(false);
    } else {
      setShowPersonal(true);
      setShowEmployer(true);
    }
  };

  const inputHandleChange = (event) => {
    setDescription(event.target.value);
  };

  useEffect(() => {
    setDescription(
      " Can you please rate my skills ? I am using Teamanics, a new career platform that uses peer ratings of skills to match people to jobs."
    );

    if (invitePeerRequest.contactNumber == "") {
      setContactNumber("");
    } else if (invitePeerRequest.contactNumber == null) {
      setContactNumber("");
    } else {
      setContactNumber(invitePeerRequest.contactNumber);
    }

    if (invitePeerRequest.email == "") {
      setEmail("");
    } else if (invitePeerRequest.email == null) {
      setEmail("");
    } else {
      setEmail(invitePeerRequest.email);
    }

    setExperiencesList(props.exps);
  }, []);

  const updateWorkedSameTeam = () => setWorkedSameTeam(!workedSameTeam);
  const updateworkedDiffTeams = () => setWorkedDiffTeams(!workedDiffTeams);
  const updateYouSupervisedPeer = () =>
    setYouSupervisedPeer(!youSupervisedPeer);
  const updatePeerSupervisedYou = () =>
    setPeerSupervisedYou(!peerSupervisedYou);
  const updateB2BRelation = () => setB2bRelation(!b2bRelation);
  const updateMentoringOrTraining = () =>
    setMentoringOrTraining(!mentoringOrTraining);
  const updateCustomerRelation = () => setCustomerRelation(!customerRelation);
  const updateAcademicRelation = () => setAcademicRelation(!academicRelation);

  const getCandidateExperience = () => {
    ProfileService.getExperience().then((response) => {
      try {
        if (response.data !== null) {
          var experienceDetails = response.data;
          const objVal = {
            key: "personal",
            value: "Personal Relationship",
          };
          experiencesList.push(objVal);
          setExperiencesList(experiencesList);
        }
      } catch (err) {
        console.error("getExperience" + JSON.stringify(err));
      }
    });
  };

  return (
    <div>
      <div className="row">
        <div className="col-sm-12">
          <div>
            <div className="skill-header">
              <div>
                <div className="profile-card-title">
                  <label>
                    <h2> Ask Peers to Rate You</h2>
                  </label>
                </div>
              </div>
            </div>
            <Form className="mt-4">
              <FormGroup row>
                <Colxx sm={12}>
                  <CardTitle>
                    {invitePeerRequest.firstName +
                      " " +
                      invitePeerRequest.lastName}
                  </CardTitle>
                  <div className="row  mb-1 ml-1">
                    {email != "" && (
                      <CardSubtitle className="truncate">
                        <span>
                          <i className="iconsminds-envelope review-icon" />
                        </span>
                        {invitePeerRequest.email}
                      </CardSubtitle>
                    )}

                    {contactNumber != "" && (
                      <CardSubtitle className="truncate ml-3">
                        <span>
                          <i className="simple-icon-phone  review-icon" />
                        </span>
                        {invitePeerRequest.contactNumber}
                      </CardSubtitle>
                    )}
                  </div>
                </Colxx>
              </FormGroup>
              <FormGroup row>
                <Colxx sm={6}>
                  <FormGroup>
                    <label>How do you know this person?</label>
                    <Input
                      type="select"
                      value={selectionId}
                      onChange={handleSelectionChange}
                    >
                      <option value="">Please select</option>
                      <option value="personal">Personal Relationship</option>
                      {experiencesList.length > 0 &&
                        experiencesList.map(({ value, key }) => (
                          <option value={key}>{value}</option>
                        ))}
                    </Input>
                  </FormGroup>
                </Colxx>
              </FormGroup>

              {showEmployer && (
                <div className="dropzone mb-4">
                  <FormGroup row className="mt-2 ml-2">
                    <Colxx sm={12}>
                      <div className="row form-group">
                        <div className="col-sm-6">
                          <div className="custom-checkbox custom-control custom-control-inline">
                            <input
                              type="checkbox"
                              data-testid="invitetoratepeers-workedSameTeam"
                              className="custom-control-input"
                              name="workedSameTeam"
                              checked={workedSameTeam}
                              onChange={updateWorkedSameTeam}
                            />
                            <label
                              className="custom-control-label"
                              for="workedinthesameteam"
                            >
                              Worked in the same team
                            </label>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="custom-checkbox custom-control custom-control-inline">
                            <input
                              type="checkbox"
                              data-testid="invitetoratepeers-workedDiffTeams"
                              className="custom-control-input"
                              checked={workedDiffTeams}
                              onChange={updateworkedDiffTeams}
                            />
                            <label
                              className="custom-control-label"
                              for="exCustomInline"
                            >
                              Worked in the different team
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row form-group">
                        <div className="col-sm-6">
                          <div className="custom-checkbox custom-control custom-control-inline">
                            <input
                              type="checkbox"
                              data-testid="invitetoratepeers-youSupervisedPeer"
                              className="custom-control-input"
                              checked={youSupervisedPeer}
                              onChange={updateYouSupervisedPeer}
                            />
                            <label
                              className="custom-control-label"
                              for="youSupervisedPeer"
                            >
                              You supervised peer
                            </label>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="custom-checkbox custom-control custom-control-inline">
                            <input
                              type="checkbox"
                              data-testid="invitetoratepeers-peerSupervisedYou"
                              className="custom-control-input"
                              checked={peerSupervisedYou}
                              onChange={updatePeerSupervisedYou}
                            />
                            <label
                              className="custom-control-label"
                              for="exCustomInline"
                            >
                              peer supervised you
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="row form-group">
                        {" "}
                        <div className="col-sm-6">
                          <div className="custom-checkbox custom-control custom-control-inline">
                            <input
                              type="checkbox"
                              data-testid="invitetoratepeers-b2bRelation"
                              className="custom-control-input"
                              checked={b2bRelation}
                              onChange={updateB2BRelation}
                            />
                            <label
                              className="custom-control-label"
                              for="exCustomInline"
                            >
                              Business to business relationship
                            </label>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="custom-checkbox custom-control custom-control-inline">
                            <input
                              type="checkbox"
                              data-testid="invitetoratepeers-mentoringOrTraining"
                              className="custom-control-input"
                              checked={mentoringOrTraining}
                              onChange={updateMentoringOrTraining}
                            />
                            <label
                              className="custom-control-label"
                              for="exCustomInline"
                            >
                              Mentoring or training relationship
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row form-group">
                        {" "}
                        <div className="col-sm-6">
                          <div className="custom-checkbox custom-control custom-control-inline">
                            <input
                              type="checkbox"
                              data-testid="invitetoratepeers-customerRelation"
                              className="custom-control-input"
                              checked={customerRelation}
                              onChange={updateCustomerRelation}
                            />
                            <label
                              className="custom-control-label"
                              for="exCustomInline"
                            >
                              Customer relationship
                            </label>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="custom-checkbox custom-control custom-control-inline">
                            <input
                              type="checkbox"
                              data-testid="invitetoratepeers-academicRelation"
                              className="custom-control-input"
                              checked={academicRelation}
                              onChange={updateAcademicRelation}
                            />
                            <label
                              className="custom-control-label"
                              for="exCustomInline"
                            >
                              Academic relationship
                            </label>
                          </div>
                        </div>
                      </div>
                    </Colxx>{" "}
                  </FormGroup>
                </div>
              )}

              {showPersonal && (
                <FormGroup row>
                  <Colxx sm={12}>
                    <label>
                      Include a personalized message with your request.
                    </label>
                    <Input
                      rows="4"
                      data-testid="invitetoratepeers-description"
                      type="textarea"
                      name="description"
                      onChange={inputHandleChange}
                      value={description}
                    />
                  </Colxx>
                </FormGroup>
              )}

              <div className="mt-4">
                {(showEmployer || showPersonal) && (
                  <Button
                    color="primary"
                    className="mr-4"
                    onClick={sendPeerRequest}
                  >
                    Send rating request
                  </Button>
                )}
                <Button color="primary" onClick={close}>
                  Cancel
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default InviteToRatePeers;
